import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

// N-042: компактный индикатор статуса интеграции (API) в шапке — клик ведёт
// на подробную страницу /api с технической информацией по всем источникам.
export default function ApiStatusBadge({ tokenKey }) {
  const navigate = useNavigate();
  const [me, setMe] = useState(null);

  const load = useCallback(() => {
    const headers = { Authorization: 'Bearer ' + localStorage.getItem(tokenKey) };
    axios.get(`${API}/clinic-cabinet/me`, { headers }).then(r => setMe(r.data)).catch(() => {});
  }, [tokenKey]);

  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [load]);

  if (!me) return null;

  // N-092: у сети "по учреждениям" (нет своего api_endpoint) индикатор раньше был всегда
  // ⚪ независимо от реального состояния филиалов — хотя агрегированный api_status сети
  // уже честно считается на бэке (N-086: active, только если ответили ВСЕ учреждения).
  let dot, label;
  if (me.target_type === 'network' && !me.has_own_api) {
    if (me.api_status === 'active') { dot = '🟢'; label = 'API активно (все учреждения)'; }
    else if (me.api_status === 'failed') { dot = '🔴'; label = 'Ошибка API (учреждения)'; }
    else { dot = '⚪'; label = 'Опрос через учреждения'; }
  } else if (!me.has_own_api) {
    dot = '⚪'; label = 'API не настроен';
  } else if (me.api_status === 'active') {
    dot = '🟢'; label = 'API активен';
  } else if (me.api_status === 'failed') {
    dot = '🔴'; label = 'Ошибка API';
  } else {
    dot = '⚪'; label = 'Не проверено';
  }

  return (
    <div style={s.pill} title="Статус интеграции — подробнее" onClick={() => navigate('/api')}>
      <span>{dot}</span>
      <span style={s.label}>{label}</span>
    </div>
  );
}

const s = {
  pill: { display: 'flex', alignItems: 'center', gap: 6, background: '#fff', border: '1px solid #eef2f7', borderRadius: 10, padding: '8px 14px', fontSize: 13, color: '#475569', height: 40, boxSizing: 'border-box', cursor: 'pointer' },
  label: { whiteSpace: 'nowrap' },
};
